import { createContext } from "react";

const defaultValue = {};
const CartContext = createContext(defaultValue);

export default CartContext;